import { inject } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivateFn,
    Router,
    RouterStateSnapshot,
} from '@angular/router';
import { Role } from '../models/role';
import { AuthService } from './auth.service';

export function authGuard(roles?: Role[]): CanActivateFn {
    return (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
        const router = inject(Router);
        const authService = inject(AuthService);

        const user = authService.userValue;
        if (user.user) {
            // role not authorized so redirect to home page
            if (roles && !roles.includes(user.user.role)) {
                console.log('role not authorized so redirect to home page');
                router.navigate(['/login']);
                return false;
            }
            return true;
        }

        // not logged in so redirect to login page with the return url
        router.navigate(['/login'], {
            queryParams: { returnUrl: state.url },
        });
        return false;
    };
}

export function LoginGuard(shouldBeLoggedIn: boolean): CanActivateFn {
    return (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
        const router = inject(Router);
        const authService = inject(AuthService);

        const user = authService.userValue;

        if (shouldBeLoggedIn) {
            // Allow access only if the user is logged in
            if (user?.user) {
                return true;
            }

            // Redirect to login if the user is not logged in
            router.navigate(['/'], {
                queryParams: { returnUrl: state.url },
            });
            return false;
        } else {
            // If the user is logged in and should not access this route
            if (user?.user?.role) {
                handleRouting(router, user.user.role); // Redirect to the appropriate page
                return true;
            }

            // Allow access for users who are not logged in
            return true;
        }
    };
}

function handleRouting(router, userRole): void {
    if (userRole === Role.Admin) {
        console.log(1);
        router.navigate(['/home/dashboard']);
    } else if (userRole === Role.EntityAdmin) {
        console.log(2);
        router.navigate(['/home/dashboard']);
    } else if (userRole === Role.Entity) {
        console.log(3);
        router.navigate(['/home/dashboard']);
    } else if (userRole === Role.Assessor) {
        console.log(4);
        router.navigate(['/home/dashboard']);
    } else if (userRole === Role.LeadAssessor) {
        console.log(5);
        // router.navigate(['/home/dashboard']);
    } else if (userRole === Role.TechnicalReviewer) {
        router.navigate(['/home/dashboard']);
    } else {
        console.log(6);
        router.navigate(['/home']);
    }
}
